import {
	Box,
	Button,
	Heading,
	Link,
	Table,
	TableContainer,
	Tbody,
	Td,
	Th,
	Thead,
	Tr,
} from "@chakra-ui/react";
import { __ } from "@wordpress/i18n";
import React from "react";
import {
	Cross,
	RedCheck,
	UpgradeNow,
} from "../../../blocks/components/icons/Icons";
type Feature = {
	name: string;
	free: number;
	pro: number;
};

const featuresList: Feature[] = [
	{ name: "Lightweight & Fast", free: 1, pro: 1 },
	{ name: "Post Blocks", free: 1, pro: 1 },
	{
		name: "Performance & SEO",
		free: 1,
		pro: 1,
	},
	{ name: "Block Customization", free: 1, pro: 1 },
	{ name: "Translation Ready", free: 1, pro: 1 },
	{ name: "Responsive Design", free: 1, pro: 1 },
	{ name: "Style Anything", free: 1, pro: 1 },
	{ name: "Easy Workflow", free: 1, pro: 1 },
	{ name: "Regular Updates", free: 1, pro: 1 },
	{ name: "Custom Fonts", free: 0, pro: 1 },
	{ name: "Custom Icons", free: 0, pro: 1 },
	{ name: "Block Import/Export on Advanced Controls", free: 0, pro: 1 },
	{ name: "Section Block", free: 1, pro: 1 },
	{ name: "Banner Post Block", free: 1, pro: 1 },
	{ name: "Heading Block", free: 1, pro: 1 },
	{ name: "Grid Module Block", free: 1, pro: 1 },
	{ name: "Feature Post Block", free: 1, pro: 1 },
	{ name: "Feature Categories Block", free: 1, pro: 1 },
	{ name: "Tab Post Block", free: 1, pro: 1 },
	{ name: "Post List Block", free: 1, pro: 1 },
	{ name: "Post Video Block", free: 1, pro: 1 },
	{ name: "Advertisement Block", free: 1, pro: 1 },
	{ name: "Category List Block", free: 1, pro: 1 },
	{ name: "News Ticker Block", free: 1, pro: 1 },
	{ name: "Social Icons Block", free: 1, pro: 1 },
	{ name: "Slider Block", free: 1, pro: 1 },
	{ name: "Date & Weather Block", free: 1, pro: 1 },
	{ name: "Modal Block", free: 1, pro: 1 },
	{ name: "Chart Block", free: 0, pro: 1 },
	{ name: "Video Scrolling Block", free: 0, pro: 1 },
	{ name: "Video Popup Block", free: 0, pro: 1 },
	{ name: "Split Content Block", free: 0, pro: 1 },
];

const FreeVsPro: React.FC = () => {
	return (
		<>
			<Box
				borderRadius="base"
				border="1px"
				borderColor="gray.100"
				bgColor="white"
				mt="32px"
			>
				<TableContainer>
					<Table variant="simple">
						<Thead bg="#F8FAFF">
							<Tr borderColor="#F4F4F4">
								<Th
									textTransform="capitalize"
									color="#383838"
									fontSize="14px"
									fontWeight="600"
								>
									Feature
								</Th>
								<Th
									textTransform="capitalize"
									color="#383838"
									fontSize="14px"
									fontWeight="600"
								>
									Free
								</Th>
								<Th
									textTransform="capitalize"
									color="#383838"
									fontSize="14px"
									fontWeight="600"
								>
									Pro
								</Th>
							</Tr>
						</Thead>
						<Tbody>
							{featuresList.map((feature) => (
								<Tr key={feature.name} borderColor="#F4F4F4">
									<Td>
										{__(feature.name, "magazine-blocks")}
									</Td>
									<Td>
										{1 == feature.free ? (
											<RedCheck w="4" />
										) : (
											<Cross w="4" />
										)}
									</Td>
									<Td>
										{1 == feature.pro ? (
											<RedCheck w="4" />
										) : (
											<Cross w="4" />
										)}
									</Td>
								</Tr>
							))}
						</Tbody>
					</Table>
				</TableContainer>
			</Box>
			<Box
				p="32px"
				bg="#e8eefd"
				borderRadius="4px"
				textAlign="center"
				display="flex"
				justifyContent="center"
				mt="32px"
			>
				<Box w=" 556px">
					<Box display="flex" justifyContent="center" mb="16px">
						<UpgradeNow w="80px" h="70px" />
					</Box>
					<Heading as="h2" mb="5" fontSize="18px">
						{__("Upgrade Now", "magazine-blocks")}
					</Heading>
					<Box fontSize="14px" color="#6B6B6B">
						{__(
							"Access all premium blocks, features, and upcoming updates right away by upgrading to the Pro version.",
							"magazine-blocks"
						)}
					</Box>
					<Button
						p="10px 16px"
						as={Link}
						bgColor="#690aa0"
						mt="24px"
						color="#FFFFFF"
						lineHeight="24px"
						fontSize="14px"
						_hover={{
							bgColor: "primary.600",
							color: "#FFFFFF",
							textDecoration: "none",
						}}
						_focus={{
							bgColor: "primary.600",
							color: "#FFFFFF",
							textDecoration: "none",
							outline: 0,
						}}
						href="https://wpblockart.com/magazine-blocks/pricing/?utm_medium=dash-free-vs-pro&utm_source=magazine-blocks&utm_campaign=footer-upgrade-btn&utm_content=get-magazine-blocks-pro-now"
						isExternal
					>
						{__("Get Magazine Blocks Pro Now", "magazine-blocks")}
					</Button>
				</Box>
			</Box>
		</>
	);
};

export default FreeVsPro;
